module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Uhr.086853a1.png";